import Vue from 'vue'
import App from './App'
import router from './router'
import Vant from 'vant';
import store from './store'
import 'vant/lib/index.css';
import './permission'
import './utils/rem'

Vue.use(Vant);

Vue.config.productionTip = false
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js